import React from "react";
import { Outlet } from "react-router-dom";

const Medicines = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default Medicines;
